<script>
import Vue from 'vue'
import VueRouter from 'vue-router'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import Views from '@/components/Views'
import Login from '@/components/Login'
import Home from '@/components/Home'
import Event from '@/components/Event'
import Client from '@/components/Client'
import League from '@/components/League'
import Leagues from '@/components/Leagues'
import Results from '@/components/Results'
import Clients from '@/components/Clients'
import FixEvent from '@/components/FixEvent'
import Payment from '@/components/Payment'
import CorrectEvent from '@/components/CorrectEvent'
import CorrectIdEvent from '@/components/CorrectIdEvent'
import LiveParams from './components/LiveParams.vue'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: [
      { 
        path: '*', 
        redirect: '/'
      },
      {
        path: '/',
        component: Login
      },
      {
        path: '/pay',
        component: Payment
      },
      {
        path: '/dashboard',
        component: Home
      },
      {
        path: '/dashboard/event',
        component: Event
      },
      {
        path: '/dashboard/client',
        component: Client
      },
      {
        path: '/dashboard/clients',
        component: Clients
      },
      {
        path: '/dashboard/league',
        component: League
      },
      {
        path: '/dashboard/leagues',
        component: Leagues
      },
      {
        path: '/dashboard/results',
        component: Results
      },
      {
        path: '/dashboard/fix-event',
        component: FixEvent
      },
      {
        path: '/dashboard/correct-event',
        component: CorrectEvent
      },
      {
        path: '/dashboard/correct-id-event',
        component: CorrectIdEvent
      },
      {
        path: '/dashboard/live-params',
        component: LiveParams
      }
    ]
})

router.beforeEach((to, from, next) => {

  const publicPages = ['/','/pay'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('token');
  const hasPin = to.query['pin'] == undefined ? false : true;
  const hasEdit = to.query['edit'] == undefined ? false : true;
  const hasAction = to.query['action'] == 'edit' ? 'edit' : '';

  if (!to.path.includes('pay') && window.location.hostname.includes('payment')) {
    return next({
      path: hasPin ? `/pay?pin=${to.query.pin}&edit=${hasEdit}&action=${hasAction}` : '/pay'
    });
  }

  if (authRequired && !loggedIn) {
    return next('/');
  } else if (!authRequired && loggedIn) {
    return next({
      path: '/dashboard'
    });
  } 

  next();
})

new Vue({
  router,
  render: h => h(Views),
  components: {
    Views
  },
  mounted() {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelector('.page-loading').style.display = 'none';
    }, false);
  }
}).$mount('#app')
</script>

<style>
body {
  background-color: #222;
}
.main {
  margin-top: 70px;
}
.d-contents {
  display: contents!important;
}
.page-loading {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  background-color: #3b3b3b;
  z-index: 99999999999!important;
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>